import React, { useEffect, useState, useCallback } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Axios from "axios";
import AkkhorLayout from "../layout/akkhor";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import { confirmAlert } from "react-confirm-alert";
import { URL_LIST_ALL } from "../configs/api";
import Moment from "react-moment";
import FilePreviewList from "./FilePreviewList";
import iconsend from "../assets/img/icon-send.png"
import Loading from "../component/Loading";
import { Modal } from "react-bootstrap";
import SearchBoxModal from "../component/SearchBoxModal";
import ModalLoaiToTrinh from "./ModalLoaiToTrinh";
import ModalThemLoaiToTrinhKhac from "./ModalThemLoaiToTrinhKhac";

export default function FormToTrinh() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams(); // id tờ trình (nếu sửa)
    const { saveWorkfollow } = useSelector((state) => state.save);
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [listLoaiToTrinh, setListLoaiToTrinh] = useState([]);
    const [workfollowId, setWorkfollowId] = useState(null);
    const [reloadProgress, setReloadProgress] = useState(false);
    const [listProgress, setListProgress] = useState([]);
    const [userComment, setUserComment] = useState("");
    const [myMessage, setMyMessage] = useState("");
    const [listMessage, setListMessage] = useState([]);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [dataNewMember, setDataNewMember] = useState(null);
    const [modalAddMember, setModalAddMember] = useState(false);
    const [tempUser, setTempUser] = useState({}); // tạm lưu user đang chọn theo progress id
    const [resetKey, setResetKey] = useState(0);

    const defaultDetail = {
        title: "",
        workflow_type: 0,
        code: "",
        code_file: "",
        status: 1,
        position: 1,
        list_file: []
    };

    useEffect(() => {
        let mounted = true;
        Axios.get(URL_LIST_ALL + "crm_workflow_type?limit=1000", user.config).then((res) => {
            if (!mounted) return;
            if (res.data.status === "success") setListLoaiToTrinh(res.data.data || []);
        }).catch((e) => console.log(e));

        if (id > 0) {
            fetchMessage();
            fetchDetail()
        }
        return () => {
            mounted = false;
        };
    }, [user, id]);

    const fetchDetail = (reload = true) => {
        if (reload) setPageLoading(true)
        Axios.get(URL_LIST_ALL + "crm_workflow_walking/" + id, user.config).then((res) => {
            setPageLoading(false)
            if (res.data.status === "success") {
                const dataif = res.data.data || {};
                dataif.list_file = dataif.list_file && JSON.parse(dataif.list_file)
                dataif.file_attachments = dataif.file_attachments && JSON.parse(dataif.file_attachments)
                dataif.file_watermark = dataif.file_watermark && JSON.parse(dataif.file_watermark)
                let groupedList = groupStepsByPosition(dataif?.workflow_steps_json || []);
                dataif.groupedList = groupedList;
                setDetail(dataif);
                // nếu tờ trình lưu cả workflow_type -> set để fetch steps
                if (dataif.workflow_type) setWorkfollowId(dataif.workflow_type);
            }
        }).catch((e) => {
            console.log(e)
            setPageLoading(false)
        });
    }

    useEffect(() => {
        if (detail && listLoaiToTrinh.length > 0) {
            setWorkfollowId(Number(detail.workflow_type));
        }
    }, [detail, listLoaiToTrinh]);

    useEffect(() => {
        if (id > 0 && detail && saveWorkfollow) {
            if (saveWorkfollow.workfollow_id == detail.id) {
                if (saveWorkfollow.node_type == 'message') {
                    fetchMessage();
                }
                if (saveWorkfollow.node_type == 'workfollow') {
                    fetchDetail(false);
                    fetchMessage()
                }
            }
        }
    }, [saveWorkfollow, id]);

    const fetchSteps = useCallback(() => {
        if (!id || id == 0) {
            if (!workfollowId) {
                setListProgress([]);
                return;
            }
            setReloadProgress(true);
            Axios.get(
                URL_LIST_ALL + "crm_workflow_step?status=1&pagetype=totrinh&orderby=position-asc&wf_type=" + workfollowId,
                user.config
            )
                .then((res) => {
                    setReloadProgress(false);
                    if (res.data.status === "success") {
                        // Defensive copy and normalization
                        const data = (res.data.data || []).map((step) => {
                            const copied = { ...step };
                            // ensure list_progress exists as array
                            copied.list_progress = Array.isArray(step.list_progress) ? step.list_progress.map(p => ({ ...p })) : [];
                            return copied;
                        });
                        setListProgress(data);
                    } else {
                        console.log("Fetch steps error:", res.data.message);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setReloadProgress(false);
                });
        }
    }, [workfollowId, id, user.config]);

    useEffect(() => {
        if (workfollowId != 1) {
            fetchSteps();
        }
    }, [workfollowId]);

    const fetchMessage = useCallback(() => {
        Axios.get(URL_LIST_ALL + "crm_workflow_message?orderby=id-desc&workflow_walking_id=" + id, user.config).then((res) => {
            if (res.data.status === "success") {
                setListMessage(res.data.data)
            }
        }).catch((e) => console.log(e));
    })

    const validForm = {
        title: Yup.string().trim().nullable().required("Vui lòng nhập tên tờ trình").max(250, "Độ dài không quá 250 ký tự"),
        code: Yup.string().trim().nullable().required("Vui lòng nhập số tờ trình").max(250, "Độ dài không quá 250 ký tự"),
    };

    const formik = useFormik({
        initialValues: detail ? detail : defaultDetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape(validForm),
        onSubmit: (values, { setSubmitting }) => {
            if (!values.list_file || values.list_file.length <= 0) {
                alert("Vui lòng chọn file đính kèm");
                return false
            }
            setLoading(true);
            values.workflow_type = workfollowId
            if (id > 0 && detail) {
                if (detail.waiting_position && detail.waiting_position > 0) {
                    values.position = detail.waiting_position
                    values.waiting_position = 0
                }
            }
            const payload = {
                ...values,
                workflow_steps_json: JSON.stringify(listProgress), // 👈 thêm dòng này
            };

            const request = id > 0
                ? Axios.put(URL_LIST_ALL + 'crm_workflow_walking/' + id, payload, user.config)
                : Axios.post(URL_LIST_ALL + 'crm_workflow_walking', payload, user.config);

            request
                .then((res) => {
                    setLoading(false);
                    setSubmitting(false);
                    if (res.data.status === 'success') {
                        confirmAlert({
                            title: 'Thành công',
                            message: id > 0 ? 'Cập nhật tờ trình thành công' : 'Tạo tờ trình thành công',
                            buttons: [{
                                label: 'OK', onClick: () => {
                                    if (id > 0) {
                                        // window.location.reload()
                                    } else {
                                        window.location.href = "/edit-workflow_walking/" + res.data.id
                                    }
                                }
                            }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message || 'Có lỗi xảy ra',
                            buttons: [{ label: 'OK' }]
                        });
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    setSubmitting(false);
                    console.error(err);
                    confirmAlert({
                        title: 'Lỗi kết nối',
                        message: 'Không thể gửi yêu cầu lên máy chủ',
                        buttons: [{ label: 'OK' }]
                    });
                });
        }
    });

    const groupStepsByPosition = (steps) => {
        const grouped = {};
        steps.forEach(step => {
            const pos = step.position;
            if (!grouped[pos]) {
                grouped[pos] = {
                    step_id: step.id,
                    position: pos,
                    group_name: step.group_name,
                    department_name: step.department_name,
                    timecheck: step.timecheck,
                    member: []
                };
            }
            grouped[pos].member.push({
                id: step.id,
                user_id: step.user_id,
                fullname: step.fullname,
                step_type: step.step_type,
                action: step.action,
                position: pos,
                group_name: step.group_name,
                department_name: step.department_name,
                note_comment: step.note_comment,
                timecheck: step.timecheck
            });
        });

        // sắp xếp theo position tăng dần
        const sorted = Object.values(grouped).sort((a, b) => a.position - b.position);

        // trong mỗi nhóm, ký chính trước phụ sau
        sorted.forEach(g => {
            g.member.sort((a, b) => a.step_type - b.step_type);
        });

        return sorted;
    };

    const handleApprove = (stepId) => {
        actionChecked(stepId, { action: 1, note_comment: userComment })
    }
    const handleRequestUpdate = (stepId) => {
        if (userComment && userComment != '') {
            actionChecked(stepId, { action: 2, note_comment: userComment })
        } else {
            alert("Vui lòng đưa ra ý kiến");
        }
    }
    const giveBack = (stepId) => {
        if (userComment && userComment != '') {
            actionChecked(stepId, { action: 3, note_comment: userComment })
        } else {
            alert("Vui lòng đưa ra ý kiến");
        }
    }

    const handleReject = (stepId) => {
        if (userComment && userComment != '') {
            actionChecked(stepId, { action: 4, note_comment: userComment })
        } else {
            alert("Vui lòng đưa ra ý kiến");
        }
    }

    const actionChecked = (stepId, datasave) => {
        setButtonLoading(true)
        Axios.put(URL_LIST_ALL + 'crm_workflow_walking_steps/' + stepId, datasave, user.config).then(res => {
            setUserComment("");
            if (res.data.status === "success") {
                confirmAlert({
                    title: 'Thông báo',
                    message: 'Thao tác thành công',
                    buttons: [{
                        label: 'OK', onClick: () => {
                            setButtonLoading(false)
                            // window.location.reload()
                            fetchDetail(false)
                        }
                    }]
                });
            } else {
                setButtonLoading(false)
                confirmAlert({
                    title: 'Lỗi',
                    message: res.data.message,
                    buttons: [{ label: 'OK' }]
                });
            }
        }).catch(err => {
            console.log(err)
            setButtonLoading(false)
        });
    }

    const sendMessage = () => {
        if (myMessage && myMessage != '') {
            Axios.post(URL_LIST_ALL + 'crm_workflow_message', { workflow_walking_id: id, user_id: user.data.id, message: myMessage }, user.config).then(res => {
                if (res.data.status === "success") {
                    setMyMessage("")
                } else {
                    confirmAlert({
                        title: 'Lỗi',
                        message: res.data.message,
                        buttons: [{ label: 'OK' }]
                    });
                }
            }).catch(err => console.log(err));
        }
    }

    const deleteStep = (stepId) => {
        confirmAlert({
            title: 'Cảnh báo',
            message: 'Bạn muốn xóa vai trò của nhân sự này ra khỏi tờ trình ?',
            buttons: [{
                label: 'Đồng ý', onClick: () => {
                    Axios.put(URL_LIST_ALL + 'crm_workflow_walking_steps/' + stepId, { status: 0 }, user.config).then(res => {
                        if (res.data.status === "success") {
                            // window.location.reload()
                            fetchDetail(false)
                        } else {
                            alert(res.data.message)
                        }
                    }).catch(err => console.log(err));
                }
            }, { label: "Không" }]
        });
    }

    const mavTitle = () => {
        if (id) {
            if (detail) {
                if (detail.status == 2) {
                    return "Xem tờ trình"
                } else {
                    if (detail.author_id != user.data.id) {
                        return "Phê duyệt tờ trình"
                    }
                    return "Cập nhật tờ trình"
                }
            } else {
                return "Xem tờ trình"
            }
        } else {
            return "Thêm mới tờ trình"
        }
    }

    const addMember = (position, group_name) => {
        setDataNewMember({
            position: position,
            group_name: group_name,
            workflow_walking_id: id,
            action: 0,
            status: 1,
            user_id: null,
            step_type: 1,
        })
        setModalAddMember(true)
    }

    const actionAddMember = () => {
        setModalAddMember(false)
        setDataNewMember(null)
        Axios.post(URL_LIST_ALL + 'crm_workflow_walking_steps', dataNewMember, user.config).then(res => {
            if (res.data.status === "success") {
                fetchDetail(false)
            } else {
                confirmAlert({
                    title: 'Lỗi',
                    message: res.data.message,
                    buttons: [{ label: 'OK' }]
                });
            }
        }).catch(err => console.log(err));
    }

    const handleAddMember = (progressId) => {
        const user = tempUser[progressId];
        if (!user?.user_id) return;

        setListProgress(prev =>
            prev.map(p => {
                if (p.id === progressId) {
                    // tránh trùng user
                    const exists = p.list_progress.some(u => u.user_id === user.user_id);
                    if (exists) return p;

                    return {
                        ...p,
                        list_progress: [
                            ...p.list_progress,
                            {
                                user_id: user.user_id,
                                user_label: user.user_label,
                                kyphu: 0,
                                list_kyphu: []
                            }
                        ]
                    };
                }
                return p;
            })
        );

        // reset user tạm sau khi thêm
        setTempUser(prev => ({
            ...prev,
            [progressId]: { user_id: null, user_label: "" }
        }));
        setResetKey(prev => prev + 1);
    };

    const extractFullname = (label = "") => {
        if (!label) return "";
        let name = label.split("-")[0].split("(")[0].trim();
        name = name.replace(/\s+$/, "");
        return name;
    }
    // 🧩 Xóa người tham gia trong tiến trình
    const handleRemoveMember = (progressId, userId) => {
        setListProgress(prev =>
            prev.map(p => {
                if (p.id === progressId) {
                    return {
                        ...p,
                        list_progress: p.list_progress.filter(u => u.user_id !== userId)
                    };
                }
                return p;
            })
        );
    };

    return (
        <AkkhorLayout idrole="workflow_walking">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li><Link to="/workflow_walking">Danh sách tờ trình</Link></li>
                    <li>
                        {mavTitle()}
                    </li>
                </ul>
            </div>

            <div className="card height-auto">
                <div className="card-body pb-5">
                    <div className="heading-layout1">
                        <div className="item-title"><h3>{mavTitle()}</h3></div>
                        <div className="">
                            {detail && <>
                                {detail.status == 1 && <span className="text-info">Chưa hoàn tất</span>}
                                {detail.status == 2 && <span className="text-success">Đã được duyệt</span>}
                                {detail.status == 4 && <span className="text-danger">Đã bị hủy</span>}
                            </>}
                        </div>
                    </div>
                    {pageLoading && <Loading />}
                    {id > 0 && !detail && !pageLoading ? "Không tìm thấy tờ trình hoặc bạn không có quyền xem tờ trình này" :
                        <form className="new-added-form form-totrinh" onSubmit={formik.handleSubmit}>
                            <div className="row">
                                <div className="col-12 col-sm-3 form-group">
                                    <label>Tên tờ trình <span className="text-danger">*</span></label>
                                    {((detail && detail.position != 0) || (detail && detail.author_id != user.data.id)) ?
                                        <div className="form-control">
                                            {detail.title}
                                        </div>
                                        :
                                        <input type="text" placeholder="VD: Mua máy tính" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off"
                                            disabled={((detail && detail.position != 0) || (detail && detail.author_id != user.data.id))} />
                                    }
                                    <AlertErrorForm formik={formik} name="title" />
                                </div>

                                <div className="col-12 col-sm-3 form-group">
                                    <label>Số tờ trình <span className="text-danger">*</span></label>
                                    {((detail && detail.position != 0) || (detail && detail.author_id != user.data.id)) ?
                                        <div className="form-control">
                                            {detail.code}
                                        </div>
                                        :
                                        <input type="text" placeholder="VD: 07/2025/TTr-PCN" className="form-control height32" {...formik.getFieldProps("code")} autoComplete="off"
                                            disabled={((detail && detail.position != 0) || (detail && detail.author_id != user.data.id))} />
                                    }

                                    <AlertErrorForm formik={formik} name="code" />
                                </div>


                                <div className="col-12 col-sm-3 form-group">
                                    <label>Loại tờ trình: </label>
                                    {((detail && detail.position != 0) || (detail && detail.author_id != user.data.id)) ?
                                        <div className="form-control">
                                            {detail.type_name}
                                        </div>
                                        :
                                        <ModalLoaiToTrinh onChange={(value) => {
                                            formik.setFieldValue('type_id', value)
                                            setWorkfollowId(value)
                                        }} />
                                    }
                                </div>
                                <div className="col-12 col-sm-3 form-group">
                                    <label>Người tạo</label>
                                    {(id === 0 || id === undefined) ?
                                        <><strong>{user.data.fullname}|{user.data.part_title}</strong></>
                                        :
                                        (detail && detail.author_name) && <>
                                            <strong>{detail.author_name}|{detail.author_department}</strong><br />
                                            <small>Ngày tạo: <Moment format="DD/MM/YYYY">{new Date(detail.datecreate * 1000)}</Moment></small>
                                        </>
                                    }
                                </div>

                                <div className="col-12 col-sm-9 form-group">
                                    {detail && detail.status == 2 ?
                                        <div className="w-100">
                                            <label>Tờ trình đã được duyệt<span className="text-danger">*</span></label>
                                            <FilePreviewList formik={formik} rowname={"file_watermark"} detail={detail} id={id} />
                                        </div>
                                        :
                                        <div className="w-100">
                                            <label>File scan <span className="text-danger">*</span></label>
                                            <FilePreviewList formik={formik} rowname={"list_file"} detail={detail} id={id} />
                                        </div>
                                    }
                                    <hr />
                                    <div className="w-100">
                                        <label>Tài liệu tham khảo <small style={{ fontSize: 10 }}>(Không bắt buộc và sẽ không cho vào trong file tờ trình chính)</small></label>
                                        <FilePreviewList formik={formik} rowname={"file_attachments"} detail={detail} id={id} />
                                    </div>
                                </div>

                                {id > 0 &&
                                    <div className="col-12 col-sm-3 form-group message-group">
                                        <div className="w-100 wrapper border rounded">
                                            <div className="w-100 ms-header p-2 border-bottom">
                                                <h5 className="w-100 text-center">Hoạt động</h5>
                                            </div>
                                            <div className="list-message">
                                                {listMessage && listMessage.map((ms) => {
                                                    return <div className="w-100 message-item border-bottom" key={ms.id}>
                                                        <strong>{ms.fullname}:</strong><span>{ms.message}</span><br />
                                                        <small><span className="far fa-clock"></span> <Moment format="H:m DD/MM/YYYY">{new Date(ms.datecreate * 1000)}</Moment></small>
                                                    </div>
                                                })}
                                            </div>
                                            {(detail && (detail.im_in || detail.author_id == user.data.id)) ?
                                                <div className="message-action border-top">
                                                    <div className="input-group">
                                                        <input type="text" className="form-control" placeholder="Nhập nội dung..." value={myMessage} onChange={(e) => setMyMessage(e.target.value)} onKeyDown={(e) => {
                                                            if (e.key == 'Enter' && !e.shiftKey) {
                                                                e.preventDefault();
                                                                sendMessage()
                                                            }
                                                        }} />
                                                        <div className="input-group-prepend">
                                                            <button type="button" className="btn btn-sm btn-succss" onClick={() => sendMessage()}>
                                                                <img src={iconsend} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""
                                            }
                                        </div>
                                    </div>
                                }
                                <div className="col-12">
                                    <div className="row">
                                        <h3 className="w-100 text-center mb-3">Quy trình phê duyệt</h3>
                                        {reloadProgress && <div className="w-100 d-flex justify-content-center"><Spinner /></div>}
                                        {((id === 0 || id === undefined) && workfollowId == 1) && <>
                                            <ModalThemLoaiToTrinhKhac onChange={(e) => setListProgress(e)} />
                                        </>}
                                        {(id === 0 || id === undefined) ?
                                            listProgress.map((step, stepIndex) => {
                                                const list_department = Array.isArray(step.list_progress) ? step.list_progress : [];
                                                return (
                                                    <div className="col-12 col-sm-4 mb-3 item-totrinh" key={step.id + "_" + stepIndex}>
                                                        <div className="wrapper border rounded shaddow">
                                                            <h4 className="text-center item-header pl-3 pr-3 pt-2 pb-2 border-bottom">{stepIndex + 1}. {step.title}</h4>
                                                            <div className="w-100 pl-3 pr-3 pt-2 pb-2 info">
                                                                {list_department.map((d, progIndex) => {
                                                                    d.list_kyphu = Array.isArray(d.list_kyphu) ? d.list_kyphu : [];
                                                                    return (
                                                                        <div className="w-100 mb-2" key={progIndex}>
                                                                            <div className="user-status">
                                                                                {d.user_label ? <div className="">
                                                                                    <strong>{d.user_label}</strong><br />
                                                                                </div> : <strong>Người chịu trách nhiệm</strong>}
                                                                                <div className="check_status">
                                                                                    {d.action == 1 ?
                                                                                        <p className="text-success"><span className="fas fa-clock"></span><i> Đã ký</i></p>
                                                                                        :
                                                                                        <p className="text-warning"><span className="fas fa-clock"></span><i> Chờ ký</i></p>
                                                                                    }
                                                                                </div>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-link text-danger p-0"
                                                                                    onClick={() =>
                                                                                        handleRemoveMember(step.id, d.user_id)
                                                                                    }
                                                                                >
                                                                                    <i className="fas fa-times"></i>
                                                                                </button>
                                                                            </div>

                                                                            {/* danh sách ký phụ */}
                                                                            {d.list_kyphu.map((kp) => (
                                                                                <div className="user-status" key={kp.user_id}>
                                                                                    <strong>{kp.fullname}</strong>
                                                                                    <div className="check_status">
                                                                                        <p className="text-warning"><span className="fas fa-clock"></span><i> Chờ ký</i></p>
                                                                                    </div>

                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    );
                                                                })}
                                                                <div className="w-100 border-top mt-2 p-2">
                                                                    <SearchBoxModal
                                                                        apiname={"users"}
                                                                        placeholder="Chọn nhân sự"
                                                                        colvalue={"id"}
                                                                        colname={"fullname"}
                                                                        name={`member_${step.id}`}
                                                                        value={tempUser[step.id]?.user_label || ""}  // 👈 điều khiển giá trị
                                                                        defaultValue={""}
                                                                        resetKey={resetKey}
                                                                        onChange={(id) =>
                                                                            setTempUser(prev => ({
                                                                                ...prev,
                                                                                [step.id]: {
                                                                                    ...(prev[step.id] || {}),
                                                                                    user_id: id
                                                                                }
                                                                            }))
                                                                        }
                                                                        onLabel={(label) =>
                                                                            setTempUser(prev => ({
                                                                                ...prev,
                                                                                [step.id]: {
                                                                                    ...(prev[step.id] || {}),
                                                                                    user_label: extractFullname(label)
                                                                                }
                                                                            }))
                                                                        }
                                                                    />

                                                                    <button type="button"
                                                                        className="btn btn-sm btn-primary mt-2 w-100"
                                                                        onClick={() => handleAddMember(step.id)}
                                                                    >
                                                                        <i className="fas fa-user-plus"></i> Thêm người
                                                                    </button>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                            :
                                            <>
                                                {detail && detail.groupedList && detail.groupedList.map((group) => {
                                                    const currentUserId = user.data.id
                                                    const currentUserInGroup = group.member.some(m => m.user_id == currentUserId);
                                                    const currentUserStep = group.member.find(m => m.user_id == currentUserId);
                                                    const roleDelete = currentUserStep && (currentUserId == currentUserStep.user_id && currentUserStep.step_type == 1)
                                                    return (
                                                        <div className="col-12 col-sm-4 mb-2 item-totrinh" key={group.position}>
                                                            <div className="wrapper border rounded shaddow">
                                                                <h4 className="text-center item-header pl-3 pr-3 pt-2 pb-2 border-bottom">
                                                                    {group.position}. {group.group_name}
                                                                </h4>
                                                                <div className="w-100 pl-3 pr-3 pt-2 pb-2 info">
                                                                    {group.member.map((m) => (
                                                                        <div className="item-user" key={m.id}>
                                                                            <div className="user-status" >
                                                                                <div className="">
                                                                                    <strong>{m.fullname}</strong>

                                                                                </div>

                                                                                <div className="check_status">
                                                                                    {m.action == 1 && (
                                                                                        <p className="text-success">
                                                                                            <span className="fas fa-check-circle"></span>
                                                                                            <i className="ml-1"> Đã duyệt</i>

                                                                                        </p>
                                                                                    )}
                                                                                    {m.action == 2 && (
                                                                                        <p className="text-info">
                                                                                            <span className="fas fa-times-circle"></span>
                                                                                            <i className="ml-1"> Yêu cầu bổ sung</i>
                                                                                        </p>
                                                                                    )}
                                                                                    {m.action == 3 && (
                                                                                        <p className="text-danger">
                                                                                            <span className="fas fa-times-circle"></span>
                                                                                            <i className="ml-1"> Trả về</i>
                                                                                        </p>
                                                                                    )}
                                                                                    {m.action == 4 && (
                                                                                        <p className="text-danger">
                                                                                            <span className="fas fa-times-circle"></span>
                                                                                            <i className="ml-1"> Hủy bỏ</i>
                                                                                        </p>
                                                                                    )}
                                                                                    {m.action == 0 && (
                                                                                        <p className="text-warning">
                                                                                            <span className="fas fa-clock"></span>
                                                                                            <i className="ml-1"> Chờ ký</i>
                                                                                        </p>
                                                                                    )}
                                                                                    {m.timecheck && <small><span className="far fa-clock"></span><Moment format="H:mm DD/MM/YYYY">{m.timecheck}</Moment></small>}
                                                                                </div>
                                                                                {(((roleDelete && m.user_id != currentUserId && m.action != 1) && (detail.my_child.some(u => u.id == m.user_id)))
                                                                                    || (user.data.id == detail.author_id && detail.position == 1 && m.action != 1)) &&
                                                                                    <div className="check_status delete-group">
                                                                                        <button type="button" className="text-danger button-delete" onClick={() => deleteStep(m.id)}>
                                                                                            <span className="fas fa-trash-alt "></span><i className="ml-1"> Xóa</i>
                                                                                        </button>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                            <div className="check-comment">
                                                                                {m.note_comment &&
                                                                                    <div className="w-100">
                                                                                        <i className="far fa-comment-dots"></i><small> {m.note_comment}</small>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                            {(id > 0 && m.user_id == currentUserId && m.action != 1 && m.position == detail.position && currentUserInGroup) && (
                                                                                <>
                                                                                    <div className="mt-2">
                                                                                        <textarea
                                                                                            className="form-control mb-2"
                                                                                            placeholder="Nêu ý kiến..."
                                                                                            value={userComment}
                                                                                            onKeyDown={(e) => {
                                                                                                if (e.key == 'Enter' && !e.shiftKey) {
                                                                                                    e.preventDefault();
                                                                                                    handleApprove(currentUserStep.id)
                                                                                                }
                                                                                            }}
                                                                                            onChange={(e) => { setUserComment(e.target.value) }}
                                                                                        />
                                                                                        <div className="row">
                                                                                            <div className="col-6 mt-2">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn w-100 btn-success btn-sm me-2"
                                                                                                    onClick={() => handleApprove(currentUserStep.id)}
                                                                                                    disabled={buttonLoading}
                                                                                                >
                                                                                                    <i className="fas fa-check"></i> Ký duyệt
                                                                                                </button>
                                                                                            </div>
                                                                                            <div className="col-6 mt-2">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn w-100 btn-info text-white btn-sm me-2"
                                                                                                    onClick={() => handleRequestUpdate(currentUserStep.id)}
                                                                                                    disabled={buttonLoading}
                                                                                                >
                                                                                                    <i className="fas fa-edit"></i> Y/c bổ sung
                                                                                                </button>
                                                                                            </div>
                                                                                            <div className="col-6 mt-2">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn w-100 btn-warning text-white btn-sm me-2"
                                                                                                    onClick={() => giveBack(currentUserStep.id)}
                                                                                                    disabled={buttonLoading}
                                                                                                >
                                                                                                    <i className="fas fa-undo"></i> Trả về
                                                                                                </button>
                                                                                            </div>
                                                                                            <div className="col-6 mt-2">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="w-100 btn btn-danger btn-sm"
                                                                                                    onClick={() => handleReject(currentUserStep.id)}
                                                                                                    disabled={buttonLoading}
                                                                                                >
                                                                                                    <i className="fas fa-times"></i> Hủy bỏ
                                                                                                </button>
                                                                                            </div>
                                                                                            {buttonLoading ? <Spinner /> : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                    {detail.position != 1 &&
                                                                                        <div className="w-100 mt-2">
                                                                                            <button type="button" className="w-100 btn btn-sm btn-primary" onClick={() => {
                                                                                                addMember(currentUserStep.position, group.group_name, m.department_name)
                                                                                            }}>
                                                                                                <span className="fas fa-user-plus"></span> Thêm người ký
                                                                                            </button>
                                                                                        </div>
                                                                                    }

                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>

                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        }
                                    </div>
                                </div>

                                {((id === 0 || id === undefined) || (detail && user.data.id == detail.author_id && detail.position == 0)) &&
                                    <div className="col-12 form-group mt-5">
                                        <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">
                                            {loading ? <Spinner /> : <>Lưu tờ trình</>}
                                        </button>
                                        <button type="reset" onClick={() => formik.resetForm()} className="btn-fill-lg bg-blue-dark btn-hover-yellow">
                                            Nhập lại
                                        </button>
                                    </div>
                                }
                            </div>
                            {detail && detail.status == 2 &&
                                <div className="item-totrinh verified">
                                    <div className="wrapper">
                                        <img src="https://apihr.bhsgroup.vn/images/logo-signed.png" />
                                    </div>
                                </div>
                            }
                        </form>
                    }
                    <div className="w-100 mb-5"></div>
                </div>
            </div>
            <Modal
                show={modalAddMember}
                onHide={() => {
                    setModalAddMember(false);
                    setDataNewMember(null)
                }}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div className="w-100 d-flex justify-content-between align-items-center">
                            <h5 className="modal-title">Thêm người ký</h5>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 form-group">
                            <label>Chọn nhân sự</label>
                            <SearchBoxModal apiname={"users"} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'} defaultValue={dataNewMember && dataNewMember.user_id} name='new_member'
                                onChange={async (e) => {
                                    setDataNewMember({ ...dataNewMember, user_id: e })
                                }}></SearchBoxModal>
                        </div>
                        <div className="col-12 form-group text-center">
                            <button type="button" className="btn btn-sm btn-success" onClick={() => actionAddMember()}>Thêm vào quy trình</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </AkkhorLayout>
    );
}
